/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC, useEffect, useState } from "react";
import { Const } from "const";
import { SpinnerBack } from "./SpinnerBack";

interface Props {
  delay?: number;
}

export const SpinnerDelay: FC<Props> = ({
  delay = Const.spinnerDelayInterval,
}) => {
  const [display, setDisplay] = useState(false);
  useEffect(() => {
    const id = setTimeout(() => {
      setDisplay(true);
    }, delay);
    return () => {
      clearTimeout(id);
    };
  }, [delay]);
  return <>{display && <SpinnerBack />}</>;
};
